"use strict";
var combineLatest_1 = require('../operators/combineLatest');
function combineAll(project) {
    return function (source) { return source.lift(new combineLatest_1.CombineLatestOperator(project)); };
}
exports.combineAll = combineAll;
//# sourceMappingURL=combineAll.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rxjs/operators/combineAll.js
// module id = 577
// module chunks = 0